const region = "us-east-1";

const dev = {
	appSettingsData: {
		BuyerCognitoGroup: 'wl-dev-procurement-portal-buyers',
		SupplierCognitoGroup: 'wl-dev-procurement-portal-suppliers',
		federatedIDPProvider: 'wl-dev-procurement-portal-idp'
	},
	amplify_config: {
		Auth: {
			mandatorySignIn: true,
			region: region,
			userPoolId: "us-east-1_2bgK8QTal",
			userPoolWebClientId: "2725vl7s55d8hqde7kcrkfdjdb",
		},
		oauth: {
			domain: "wl-dev-procurement-portal.auth.us-east-1.amazoncognito.com",
			scope: [],
			redirectSignIn: "https://wl-dev-procurement-portal.com/login",
			redirectSignOut: "https://wl-dev-procurement-portal.com/login",
			// redirectSignIn: "http://localhost:3000/login",
			// redirectSignOut: "http://localhost:3000/login",
			responseType: "code",
			clientId: "2725vl7s55d8hqde7kcrkfdjdb",
		},
		API: {
			endpoints: [
				{
					name: "print",
					endpoint: "https://api.wl-dev-procurement-portal.com/print",
					region: region
				}
			]
		},
	}
}
export default dev;
